/** Paths that must not require or inject the `org` search param (OAuth callbacks, invitations). */
export const routesWithoutOrganisation = ['/accept-invitation', '/callback/git', '/callback/oauth1'];
